"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { Service } from "@/app/(site)/data/serviceData";

interface Props {
  service: Service;
  index: number;
}

export default function Card({ service, index }: Props) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      href={`/expertise/${service.slug}`}
      className="relative group overflow-hidden transition-all h-[500px] w-full block duration-500 ease-in-out transform hover:-translate-y-1"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src={service.featuredImage}
          alt={service.title}
          fill
          priority
          className={`object-cover transition-all duration-500 ease-in-out ${
            isHovered
              ? "scale-110 brightness-50 blur-[1px]"
              : "scale-100 brightness-75"
          }`}
        />
      </div>

      {/* Overlay Content */}
      <div className="relative flex flex-col justify-end h-full px-10 text-white z-10 transition-all duration-500">

        {/* Index Number (visible initially, hidden on hover) */}
        <span className={`absolute top-8 left-10 text-5xl font-bold text-white/70 select-none transition-opacity duration-500 ${
            isHovered ? "opacity-0" : "opacity-100"}`}>
          {index}
        </span>

        {/* Description (hidden initially, shown on hover) */}
        <div className={`absolute inset-0 flex items-start justify-start pt-28 pl-16 pr-10 transition-all duration-700 ease-out ${
            isHovered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="text-[18px] leading-relaxed">{service.description}</p>
        </div>

        {/* Bottom Section */}
        <div className="flex items-center justify-between pb-10 transition-opacity duration-500">

            {/* Title */}
            <h3 className="text-[18px] font-semibold leading-tight w-[90%] transition-opacity duration-500">
                {service.title}
            </h3>

            {/* Arrow Button (hidden initially, visible on hover) */}
            <div className={`flex items-center justify-center w-10 h-10 rounded-full bg-white/80 text-gray-900 transition-all duration-700 ease-out${
                isHovered ? "opacity-100 translate-y-0" : "opacity-0 translate-x-6"}`}>
                <ArrowRight size={24} className="-rotate-45" />
            </div>

        </div>
      </div>
    </Link>
  );
}
